<template>
  <a-modal
    title="图片验证码"
    :width="460"
    :visible="visible"
    @ok="onConfirm"
    @close="onCancel"
    @cancel="onCancel">
    <a-row :gutter="16">
      <a-col class="gutter-row" :span="16">
        <a-form-item>
          <a-input
            v-model="imageCode"
            size="large"
            type="text"
            placeholder="请输入图片验证码">
            <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }"/>
          </a-input>
        </a-form-item>
      </a-col>
      <a-col class="gutter-row" :span="8">
        <img :src="imageCodeUrl" alt="验证码" class="img-code" @click="restImageCodeUrl()">
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
export default {
  name: 'ImageCodeComponent',

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'visible': function(value) {
      if (value) {
        this.imageCode = ''
        this.restImageCodeUrl()
      }
    }
  },
  data() {
    return {
      imageCode: '',
      randomNum: 0,
      imageCodeUrl: ''
    }
  },
  mounted() {
    this.restImageCodeUrl()
  },
  methods: {
    onConfirm() {
      if (!this.imageCode) {
        this.$message.error('请输入图片验证码')
        return
      }
      const params = {
        randomNum: this.randomNum,
        imageCode: this.imageCode
      }
      this.$emit('confirm', params)
    },

    //重置图片验证码地址
    onCancel() {
      this.$emit('close')
    },
    restImageCodeUrl() {
      this.randomNum = (Math.random() * new Date().getTime()).toFixed(0)
      this.imageCodeUrl = this.getAppConfig().baseUrl + 'code/getCode/' + this.randomNum
    }
  }

}
</script>
<style scoped>
.img-code {
  width: 130px;
  height: 40px;
}
</style>